const animations = {
	init () {
		AOS.init({
			delay: 300,
			duration: 1000,
			once: true,
		})
	}
}
animations.init()